import { api } from './api';

export const notificationService = {
  list: async ({ unread = false, page = 1, limit = 20 } = {}) => {
    const qs = new URLSearchParams();
    if (unread) qs.set('unread', '1');
    qs.set('page', String(page));
    qs.set('limit', String(limit));
    return api.get(`/api/notifications?${qs.toString()}`, { includeStore: false });
  },

  markAsRead: async (id) => {
    return api.patch(`/api/notifications/${id}/read`, null, { includeStore: false });
  },

  markAllAsRead: async () => {
    return api.post('/api/notifications/read-all', null, { includeStore: false });
  },
};

export default notificationService;
